// Chatbot, voice e concierge vivono tutti su una inbox Channel::Api: li
// distingue solo additional_attributes.channel_subtype. Questa e' la fonte
// unica della regola lato dashboard (lato Rails: AgentAi::ApiChannelSubtype):
//   - chatbot   = sottotipo vuoto (canali legacy, nati prima del sottotipo)
//                 oppure 'chatbot'
//   - voice     = 'voice'
//   - concierge = 'concierge' (ospiti gia' in struttura, QR in camera)
//   - qualunque altro valore non e' nessuno dei tre.
// L'elenco e' esplicito apposta: con il vecchio test "tutto cio' che non e'
// voice e' il chatbot" un sottotipo nuovo avrebbe ereditato in silenzio pagine,
// badge e stato live del chatbot. Il concierge ha un nome suo (e un badge
// suo): dove oggi si comporta come il chatbot (stato live) e' una scelta
// scritta li'.
const API_INBOX_CHANNEL_TYPE = 'Channel::Api';

const API_CHANNEL_SUBTYPE = Object.freeze({
  CHATBOT: 'chatbot',
  VOICE: 'voice',
  CONCIERGE: 'concierge',
});

const normalizeApiChannelSubtype = (subtype = '') =>
  String(subtype ?? '')
    .trim()
    .toLowerCase();

// Sottotipo normalizzato. Legge solo additional_attributes e non il tipo di
// canale: vale anche per gli oggetti della sidebar, che espongono il tipo come
// `type` invece di `channel_type`.
const apiChannelSubtype = (inbox = null) =>
  normalizeApiChannelSubtype(inbox?.additional_attributes?.channel_subtype);

const isChatbotApiSubtype = (subtype = '') => {
  const normalizedSubtype = normalizeApiChannelSubtype(subtype);

  return (
    normalizedSubtype === '' ||
    normalizedSubtype === API_CHANNEL_SUBTYPE.CHATBOT
  );
};

const isVoiceApiSubtype = (subtype = '') =>
  normalizeApiChannelSubtype(subtype) === API_CHANNEL_SUBTYPE.VOICE;

const isConciergeApiSubtype = (subtype = '') =>
  normalizeApiChannelSubtype(subtype) === API_CHANNEL_SUBTYPE.CONCIERGE;

const isApiInbox = (inbox = null) =>
  inbox?.channel_type === API_INBOX_CHANNEL_TYPE;

const isChatbotApiInbox = (inbox = null) =>
  isApiInbox(inbox) && isChatbotApiSubtype(apiChannelSubtype(inbox));

const isVoiceApiInbox = (inbox = null) =>
  isApiInbox(inbox) && isVoiceApiSubtype(apiChannelSubtype(inbox));

const isConciergeApiInbox = (inbox = null) =>
  isApiInbox(inbox) && isConciergeApiSubtype(apiChannelSubtype(inbox));

export {
  API_CHANNEL_SUBTYPE,
  apiChannelSubtype,
  isChatbotApiInbox,
  isChatbotApiSubtype,
  isConciergeApiInbox,
  isConciergeApiSubtype,
  isVoiceApiInbox,
  isVoiceApiSubtype,
};
